'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/MobileDropdownMenu.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileDropdownMenu = function (_BcReactComponent) {
  _inherits(MobileDropdownMenu, _BcReactComponent);

  function MobileDropdownMenu(props) {
    _classCallCheck(this, MobileDropdownMenu);

    var _this = _possibleConstructorReturn(this, (MobileDropdownMenu.__proto__ || Object.getPrototypeOf(MobileDropdownMenu)).call(this, props));

    _this.bindAll('handleSelectChange');
    return _this;
  }

  _createClass(MobileDropdownMenu, [{
    key: 'handleSelectChange',
    value: function handleSelectChange(e) {
      var index = e.target.selectedIndex;
      var option = _immutable2.default.Iterable.isIterable(this.props.options) ? this.props.options.get(index) : this.props.options[index];
      this.props.handleSelect(option);
    }
  }, {
    key: 'isOptionSelected',
    value: function isOptionSelected(item) {
      return item === this.props.selected ? 'selected' : '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'select',
        { className: 'cp-mobile-dropdown-menu', onChange: this.handleSelectChange },
        this.props.options.map(function (item) {
          return _react2.default.createElement(
            'option',
            { selected: _this2.isOptionSelected(item.label), key: item.key },
            item.label
          );
        })
      );
    }
  }]);

  return MobileDropdownMenu;
}(_baseBcReactComponent2.default);

MobileDropdownMenu.propTypes = {
  handleSelect: _react2.default.PropTypes.func.isRequired,
  options: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
    key: _react2.default.PropTypes.string,
    label: _react2.default.PropTypes.string,
    value: _react2.default.PropTypes.string
  })),
  selected: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string])
};

exports.default = MobileDropdownMenu;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-mobile-dropdown-menu/lib/components/MobileDropdownMenu.component.js
// module id = 631
// module chunks = 0 1 9 10 11